import { createAction } from 'typesafe-actions'
import { MessageState } from '../../types'

export const deleteEditMessageAction = createAction('@message/DELETE_EDIT_MESSAGE')()

const success = (state: MessageState): MessageState => {
  return {
    ...state,
    editMessage: null
  }
}

export const deleteEditMessageHandle = { asyncAction: deleteEditMessageAction, success }
